import React from "react";

import IntegrationMark from "./IntegrationMark";
import { INTEGRATIONS_MARK_SIZE } from "./IntegrationMark.confg";
import { CosignStatus } from "manager/interfaces/api/cosign";
import { CosignBadgeHouseIcon } from "../app-summary/header/CosignBadge";


const COSIGN_STATUS_CONFIG: Record<CosignStatus, {
  message: string;
  iconColor: string;
}> = {
  pending: {
    message: "Current application has cosign pending",
    iconColor: "#F59E0B", // Amber
  },
  approved: {
    message: "Current application has cosign approval",
    iconColor: "#10B981", // Green
  },
  denied: {
    message: "Current application has cosign denial",
    iconColor: "#EF4444", // Red
  },
  canceled: {
    message: "Current application has cosign cancellation",
    iconColor: "#6B7280", // Gray
  },
  initiated: {
    message: "Current application has cosign initiation",
    iconColor: "#6B7280", // Gray
  },
  expired: {
    message: "Current application has cosign expiration",
    iconColor: "#6B7280", // Gray
  },
};

export interface CosignIntegrationMarkProps {
  status?: CosignStatus;
  lg?: boolean;
  displayStatus?: string;
}

const CosignIntegrationMark = ({
  status,
  lg,
  displayStatus,
}: CosignIntegrationMarkProps) => {
  const size = lg ? INTEGRATIONS_MARK_SIZE.lg : INTEGRATIONS_MARK_SIZE.sm;

  const config = status === 'pending' && displayStatus ? { message: displayStatus, iconColor: "#F59E0B" } : COSIGN_STATUS_CONFIG[status];

  return (
    <IntegrationMark
      IntegrationIcon={() => <span style={{margin: "0 0 1em 0"}}><CosignBadgeHouseIcon isEnabled /></span>}
      popoverLabel={config.message}
      size={size}
    />
  );
};

export default CosignIntegrationMark;
